import { createAuthHooks } from "@growing/api";
import { apiClient } from "../../client";

// 공유 패키지의 Auth hooks 사용 (student role)
const authHooks = createAuthHooks(apiClient, { role: "student" });

// 기존 훅 이름 변경 (useGetCheckUserId → usePostCheckUserId)
export const usePostCheckUserId = authHooks.usePostCheckUserId;
export const usePostSignup = authHooks.usePostSignup;
export const usePostLogin = authHooks.usePostLogin;
export const useGetProfile = authHooks.useGetProfile;
